// node modules
import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { useQuery, gql } from '@apollo/client';

export const GET_SUBSCRIPTION_PLANS = gql`
  query GetSubscriptionPlanIds($platform: String!) {
    SubscriptionPlans(platform: $platform) {
      id
      default
    }
  }
`;

function InAppOfferPrice(props) {
  const { className, productId } = props;
  const { data } = useQuery(GET_SUBSCRIPTION_PLANS, {
    variables: {
      platform: window.cordova.platformId,
      _authenticated: true,
    },
  });
  const defaultPlan =
    data?.SubscriptionPlans?.find(plan => plan.default) || data?.SubscriptionPlans[0];
  const product = useSelector(state => state.inAppPayment.products[productId || defaultPlan?.id]);
  if (product && product.price && product.billingPeriodUnit) {
    return (
      <div className={className}>
        <p>
          Join today for <b>{product.price}</b>/{product.billingPeriodUnit.toLowerCase()}
        </p>
      </div>
    );
  }
  return null;
}

InAppOfferPrice.propTypes = {
  className: PropTypes.string,
  productId: PropTypes.string,
};

InAppOfferPrice.defaultProps = {
  className: '',
  productId: null,
};

export default InAppOfferPrice;
